export default __webpack_public_path__ + "static/media/bitcoin.aebd4ac5.svg";